import interceptedAxios from '../../../utils/interceptedAxios'

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export async function exportGraphDataService (
  startDateTime: string,
  endDateTime: string,
  request: string,
  type: string,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/device/data/export?startDateTime=${startDateTime}&endDateTime=${endDateTime}&timeZone=${userTimezone}`
  interceptedAxios
    .post(url, request, {
      timeout: 10000,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'text/csv' })
      )
      const link = document.createElement('a')
      link.href = url
      const today = new Date()
      const time = today.toLocaleTimeString([], {
        hourCycle: 'h23',
        minute: '2-digit'
      })
      link.setAttribute(
        'download',
        `DeviceGrapData_${type}_${
          today.getMonth() + 1
        }-${today.getDate()}-${today.getFullYear()} ${today.getHours()}_${time}.csv`
      )
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)
      onSuccess(response)
    })
    .catch((error) => {
      onFailure(error)
    })
}
